export default {
  CARFAX: 'carfax',
  TRADALGO_US: 'tradalgo-us',
  VMR: 'vmr',
};
